export default __webpack_public_path__ + "static/bulbasaur-53ed762221514b3f5b20c79595ef7241.png";